export default "__VITE_ASSET__a5cd461d__"